import { Component, OnInit } from "@angular/core";
import { SharedService } from "../../../../services/shared.service";
import {
  FormGroup,
  FormBuilder,
  FormControl,
  Validators,
} from "@angular/forms";
import { RequestModel } from "../../../../models/dashboard/request.model";
import { DashboardService } from "../../../../services/dashboard.service";
import { DriverModel } from "../../../../models/dashboard/driver.model";
@Component({
  selector: "app-download-external-source-blocco",
  templateUrl: "./download-external-source-blocco.component.html",
  styleUrls: ["./download-external-source-blocco.component.css"],
})
export class DownloadExternalSourceBloccoComponent implements OnInit {
  isLoading: boolean;
  blocco: any;
  tipo: string;
  json: any;

  taxonomy: any;
  taxonomyTypes: Array<any> = [];
  form: FormGroup;
  request: RequestModel;
  driver: DriverModel;

  constructor(
    private _sharedService: SharedService,
    private _dashboardService: DashboardService,
    private formBuilder: FormBuilder
  ) {}

  ngOnInit() {
    this.taxonomyTypes = this._sharedService.getTaxonomyTypes();
    if (!this.taxonomyTypes) {
      this._dashboardService.getTaxonomyTipo().subscribe((res) => {
        this.taxonomyTypes = res;
        this._sharedService.setTaxonomyTypes(res);
      });
    }
  }

  inizializeForm() {
    this.getBlocco();
    this.getDriver();
    this.form = this.formBuilder.group({
      taxonomy: new FormControl("", Validators.compose([Validators.required])),
    });
    this._dashboardService.getTaxonomy(this.blocco.id).subscribe((res) => {
      this.taxonomy = res;
      if (res) {
        this.form.get("taxonomy").setValue(res.taxonomyValue);
      }
    });
    this.isLoading = false;
  }

  getBlocco() {
    this.blocco = this._sharedService.getBlocco();
    this.tipo = this.blocco.tipoBlocco
      ? this.blocco.tipoBlocco
      : this.blocco.codiceBloccoTipo;
    // this.json = this.blocco.json;
  }
  getDriver() {
    this.driver = this._sharedService.getDriver();
  }

  onJsonChange(event) {
    this.json = event;
  }
}



// WEBPACK FOOTER //
// C:/ETT/Progetti/JumpvNext/Angular/AgentiWebUI/AgentiWebConqordOil.Web.UI/src/app/components/utils/item-manager/download-external-source-blocco/download-external-source-blocco.component.ts